import bytes from 'bytes'
import _ from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import { MdFileDownload } from 'react-icons/md'

import './styles.scss'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getIdToken } from '../../../lib/cognito'
import { open } from '../../../store/modules/previewer'
import { defaultFileTypes } from '../FormBuilder'

export const openUrlInNewTab = url => {
  getIdToken().then(idToken => {
    const sing = url.indexOf('?') !== -1 ? '&' : '?'
    window.open(`${url}${sing}authorization=Bearer ${idToken}`, '_blank')
  })
}

class DownloadLink extends React.Component {
  constructor (props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
  }

  handleClick = () => {
    const { meta } = this.props
    this.props.open({
      mimeType: meta.mime_type,
      name: meta.filename,
      id: meta?.id
    })
  }

  render () {
    const { patientId, type, clientName, meta } = this.props

    // TODO: use backend's base url in the link when environment variables are
    // properly configured in frontend's assets (i.e. via Docker). Currently,
    // it works only in production because both backend and frontend are on the
    // same domain.
    const url =
      type === 'MessageAttachment'
        ? `/api/patients/${patientId}/messages/${meta?.chatId}/attachment/${meta?.id}?participant=${meta?.participantId}&clientName=${clientName}&downloadType=attachment`
        : `/api/patients/${patientId}/documents/${meta?.id}?documentType=${type}&clientName=${clientName}&downloadType=inline`

    const openInModal = defaultFileTypes[_.get(this.props, 'meta.mime_type')]
    return (
      <div className='nh-download-link'>
        {openInModal
          ? (
            <button
              onClick={this.handleClick}
              className='document-link'
            >
              {_.get(this.props, 'meta.filename')}
              {' '}
              (
              {bytes(_.get(this.props, 'meta.size'))}
              )
            </button>
          )
          : (
            <span style={{ marginTop: '2.6rem' }}>
              {_.get(this.props, 'meta.filename')}
              {' '}
              (
              {bytes(_.get(this.props, 'meta.size'))}
              )
            </span>
          )}

        <button
          className='nh-download-icon'
          onClick={() => {
            openUrlInNewTab(url)
          }}
          style={{ marginLeft: '0.4rem' }}
        >
          <MdFileDownload size='1.3rem' />
        </button>
      </div>
    )
  }
}

DownloadLink.propTypes = {
  patientId: PropTypes.string.isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  type: PropTypes.oneOf([
    'DocumentReference',
    'DiagnosticReport',
    'MessageAttachment'
  ]).isRequired
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      open
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(DownloadLink)
